'use strict';

var React = require('react');
var appTypes = require('../../types/appTypes');
var ReactDOM = require('react-dom');
var _ = require('underscore');
var AutoSizeHelper = require('../common/AutoSizeHelper');
var RadioItem = require('../common/RadioItem');
var styleHelper = require('../../helper/styleHelper');
var LinkHelper = require('../common/LinkHelper');
var util = require('../../helper/util');

var RadioButtonGroup = React.createClass({

  getInitialState: function () {
    return {
      selectedIndex: this.props.selectedIndex
    };
  },

  parseItem: function (itemText) {
    var item = JSON.parse(JSON.stringify(this.props));
    var cfg;
    cfg = this.parseState(itemText);
    item.text = cfg.text;
    item.gap = 5;
    return item;
  },

  parseState: function (text) {
    var disabled = false;
    text = text.trim();

    if (text.indexOf('()') === 0) {
      text = text.replace('()', '');
    } else if (text.indexOf('( )') === 0) {
      text = text.replace('( )', '');
    } else if (text.indexOf('(o)') === 0) {
      text = text.replace('(o)', '');
    } else if (text.indexOf('(O)') === 0) {
      text = text.replace('(O)', '');
    } else if (text.charAt(0) === '-' && text.charAt(text.length - 1) === '-') {
      text = text.substring(1, text.length - 1);
      disabled = true;
      if (text.indexOf('(o)') === 0) {
        text = text.replace('(o)', '');
      } else if (text.indexOf('(O)') === 0) {
        text = text.replace('(O)', '');
      } else if (text.indexOf('()') === 0) {
        text = text.replace('()', '');
      } else if (text.indexOf('( )') === 0) {
        text = text.replace('( )', '');
      }
    };

    return {
      isDisabled: disabled,
      text: text
    };
  },

  parseItems: function () {
    var TextUtil = util.Text;
    
    {/*
      var text = styleHelper.getText(this.props);
      text = TextUtil.removeLastEmptyRow(text);
    */}

    var text = TextUtil.removeLastEmptyRow(styleHelper.getText(this.props));

    var textArray = TextUtil.delimitText(text, TextUtil.DM_RETURN);
    var i;
    var itemText;
    var resultArray = [];
    var links = LinkHelper.tranItemRect(this.props.itemRect) || this.props.links.link;
    var item;
    var rect;
    for (i = 0; i < textArray.length; i++) {
      itemText = textArray[i].trim();
      item = this.parseItem(itemText);
      rect = links[i].area ? links[i].area.coords : links[i];
      item.x = rect.left;
      item.y = rect.top;
      item.w = rect.width;
      item.h = rect.height;
      resultArray.push(item);
    }

    return resultArray;
  },

  componentDidMount: function () {
    $(ReactDOM.findDOMNode(this)).on('itemClick', this.onItemClick);
  },

  render: function () {
    var itemArray = this.parseItems();
    var itemStyle;
    var style = styleHelper.StyleUtil(this.props).default({
      overflow: 'hidden',
      position: 'absolute'
    }).size().text().align().style;
    return (
      <div style={style}>
        {
          itemArray.map(function (item, index) {
            item.isSelected = index === this.state.selectedIndex;
            itemStyle = styleHelper.StyleUtil(item).default({position: 'absolute'}).bounds().style;
            return (<div key={index} style={itemStyle} onClick={this.onSelect.bind(this, index)}><RadioItem {...item}/>
            </div>);
          }, this)
        }
      </div>
    );
  },

  onSelect: function (index) {
    this.setState({selectedIndex: index});
  },

  onItemClick: function (e, index) {
    this.onSelect(index);
  }

});


module.exports = RadioButtonGroup;



// WEBPACK FOOTER //
// ./src/views/Components/RadioButtonGroup.jsx